// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---smooth-doc-smooth-doc-src-templates-doc-js": () => import("./../../../smooth-doc/smooth-doc/src/templates/doc.js" /* webpackChunkName: "component---smooth-doc-smooth-doc-src-templates-doc-js" */),
  "component---smooth-doc-smooth-doc-src-templates-page-js": () => import("./../../../smooth-doc/smooth-doc/src/templates/page.js" /* webpackChunkName: "component---smooth-doc-smooth-doc-src-templates-page-js" */)
}

